/**
 * Zod schema for draft assessment / synthesis output.
 * Used with structured outputs to get guaranteed-valid JSON from the LLM.
 * Mirrors DraftAssessment/AssessmentSection in investigation/types.ts.
 */

import { z } from 'zod';

const SectionSchema = z.object({
  title: z.string().min(1),
  content: z.string().min(1),
  citations: z.array(z.string()),
});

export const DraftAssessmentSchema = z.object({
  executiveSummary: z.string().min(1),
  sections: z.array(SectionSchema).min(1),
});

export type DraftAssessmentOutput = z.infer<typeof DraftAssessmentSchema>;
